import { ca } from '@cian/analytics';

type TTrackOpenChatListItemClickParams = {
  chatId: string;
  opponentId?: number | null;
  ownerId?: number | null;
};

export const trackOpenChatListItemClick = ({ chatId, opponentId, ownerId }: TTrackOpenChatListItemClickParams) => {
  try {
    ca('eventSite', {
      name: 'oldevent',
      category: 'Chat',
      action: 'Open_sopr',
      label: '',
      page: {
        extra: {
          chat_id: chatId,
          owner_id: ownerId,
          opponent_id: opponentId,
        },
      },
    });
  } catch (error) {
    console.debug('trackOpenChatListItemClick', error);
  }
};
